const { InspectorControls } = wp.blockEditor;
const { PanelBody, TextControl, ToggleControl, SelectControl } = wp.components;

import ImageControl from '../../wp-controlers/mediaUpload';

const Inspector = ({ attributes, setAttributes }) => {
  const { cardButtonHref, isModal, variant } = attributes;

  return (
    <InspectorControls>
      <PanelBody>
        <ImageControl
          image="icon"
          attributes={attributes}
          setAttributes={setAttributes}
        />

        <TextControl
          label="Url Botão do Card"
          value={cardButtonHref}
          onChange={(cardButtonHref) => setAttributes({ cardButtonHref })}
        />

        <ToggleControl
          label="Este item deve abrir um modal?"
          checked={isModal}
          onChange={() => setAttributes({ isModal: !isModal })}
        />

        <SelectControl
          label="Selecione o estilo do card"
          title="Selecione o estilo do card"
          value={variant}
          options={[
            { label: 'Padrão', value: 'defaultSelf' },
            { label: 'Horizontal com fundo azul', value: 'horizontalBlueSelf' },
          ]}
          onChange={(position) => setAttributes({ variant: position })}
        />
      </PanelBody>
    </InspectorControls>
  );
};

export default Inspector;
